import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const statusBadgeVariants = cva(
  'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
  {
    variants: {
      variant: {
        success:
          'bg-success-bg text-success-bg-foreground ring-success-bg-foreground/20',
        warning:
          'bg-warning-bg text-warning-bg-foreground ring-warning-bg-foreground/20',
        error:
          'bg-error-bg text-error-bg-foreground ring-error-bg-foreground/20',
        info: 'bg-info-bg text-info-bg-foreground ring-info-bg-foreground/20',
        default: 'bg-muted text-muted-foreground ring-muted-foreground/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface StatusBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusBadgeVariants> {}

const StatusBadge = React.forwardRef<HTMLSpanElement, StatusBadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <span
        className={cn(statusBadgeVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
StatusBadge.displayName = 'StatusBadge';

export { StatusBadge, statusBadgeVariants };
